import { slotList } from "@/Util/manifest";

export default {
  User: {
    title: "Korisnik",
    plural: "Korisnici",
    labelNew: "Novi korisnik",
    hasDeleted: true,
    noDelete: true,
    columns: slotList([
      {
        name: "username",
        label: "Korisničko ime",
        default: true,
        searchComponent: "SearchText",
      },
      {
        name: "email",
        label: "Email",
        default: true,
        searchComponent: "SearchText",
      },
      {
        name: "group",
        label: "Grupa",
        default: true,
        enum: ["Administrator"],
        searchComponent: "SearchEnum",
      },
      {
        name: "photo",
        label: "Slika",
        default: true,
        type: "file"
      }
    ]),
    form: slotList([
      {
        id: "basic", priority: 0,
        title: "Basic",
        fields: slotList([
          {
            id: "username", priority: 0,
            label: "Username",
            cols: 3,
          },
          {
            id: "email", priority: 0,
            label: "Email",
            type: "email",
            cols: 3,
          },
          {
            id: "password", priority: 0,
            label: "Password",
            type: "password",
            cols: 3,
          },
          {
            id: "group", priority: 0,
            label: "Group",
            enum: ["Administrator"],
            cols: 3,
          }
        ]),
      }
    ]),
  },
}
